<template>
  <div class="com-form-item">
    <span class="label" v-if="title">{{ title }}</span>
    <span class="icon-type" v-if="type"
      ><img :class="`img-${type}`" :src="renderIcon(type)"
    /></span>
    <slot></slot>
  </div>
</template>

<script>
import location from "../assets/images/icon-location.png";
import industry from "../assets/images/icon-industry.png";
import name from "../assets/images/icon-name.png";
import org from "../assets/images/icon-org.png";
import font from "../assets/images/icon-font.png";
export default {
  name: "FormItem",
  props: {
    title: String,
    type: String
  },
  data() {
    return {
      icons: {
        location,
        industry,
        name,
        org,
        font
      }
    };
  },
  methods: {
    renderIcon(type) {
      return this.icons[type];
    }
  },
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.com-form-item {
  height: 50px;
  line-height: 22px;
  color: rgba(119, 119, 119, 1);
  background: #fff;
  box-sizing: border-box;
  display: inline-block;
  vertical-align: middle;
  border-radius: 4px;
  border: 1px solid #ccc;
  position: relative;
  padding-left: 35px;

  .label {
    display: inline-block;
    vertical-align: top;
    height: 22px;
    border-right: 1px solid rgba(221, 221, 221, 1);
    padding: 0 12px;
    margin: 14px 0;
  }
  .icon-type {
    width: 50px;
    text-align: center;
    vertical-align: 2px;
    position: absolute;
    left: 0;
    top: 0;
    height: 50px;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 22px;
    }
    .img-location {
      width: 16px;
    }
    .img-industry {
      width: 18px;
    }
  }

  .el-select {
    width: 100%;
  }
  .el-input__inner {
    border: none;
    height: 48px;
  }
}
</style>
